import { isNil, isNotNil } from '@flowio/is';
import { RequestPaymentParameters } from '../types';
import filterObjectNils from './filterObject';

export default function convertPaymentAddrToBillingAddr(
  addr?: RequestPaymentParameters['data']['orderInformation']['billingAddress'],
): io.flow.v0.models.BillingAddress | undefined {
  if (isNil(addr)) {
    return undefined;
  }
  return filterObjectNils<io.flow.v0.models.BillingAddress>({
    city: addr.location.city,
    country: addr.location.country,
    name: {
      first: addr.contact.firstName,
      last: addr.contact.lastName,
    },
    postal: addr.location.postal,
    province: addr.location.province,
    streets: isNotNil(addr.location.streets) ? addr.location.streets : undefined,
  });
}
